import { Inject, Injectable } from '@angular/core';
import { ILazyLoader } from '@caslink/common-client/src/typings/models';
import { DOCUMENT } from '@angular/common';


@Injectable({
    providedIn: 'root'
})
export class LazyLoaderService implements ILazyLoader {
    public static $name: string = 'clLazyLoaderService';

    constructor(@Inject(DOCUMENT) private document: Document) { }

    load(url: string, callback?: () => any): boolean {
        if (this.isScriptLoadedInHead(url)) {
            if (callback) {
                this.callbackWrapper(callback);
            }
            return true;
        } else {
            const scriptTag = this.document.createElement('script');
            scriptTag.src = url;
            if (callback) {
                this.document.body.onload = () => this.callbackWrapper(() => callback(), this.document.body);
            }
            const head = this.document.getElementsByTagName('head');
            if (head?.length === 1) {
                head[0].appendChild(scriptTag);
            }
            return false;
        }
    }

    private isScriptLoadedInHead(url: string): boolean {
        const parsedUrl = url.replace(/\r?\n|\r/g, "");
        return Boolean(this.document.querySelector('head')?.querySelector(`script[src="${parsedUrl}"]`));
    }

    private callbackWrapper(callback: () => any, element: HTMLElement | null = null) {
        callback();
        if (element) {
            element.onload = null;
        }
    }
}
